export enum Status {
  ATIVO = 'A',
  INATIVO = 'I'
}

export class DefaultModel {

  public id: number;
  
  public status: string;
  
  public idTenant?: number;

  public dataAlteracao?: Date;

  public dataCriacao?: Date;

  constructor() {
  }

  public getIdTenant?(): number {
    return this.idTenant;
  }

  public setIdTenant?(idTenant: number): void {
    this.idTenant = idTenant;
  }

  public getId?(): number {
      return this.id;
  }

  public setId?(id: number): void {
      this.id = id;
  }

  public getStatus?(): string {
      return this.status;
  }

  public setStatus?(status: string) {
      this.status = status;
  }
}
